/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface SeedOAuthAuthorizeUpdateSpec { 
    /**
     * Whether authorization was done on this org or not
     */
    authorized?: boolean;
    /**
     * Authorize state. Need to validate against values in OAuthAppAwsAccountCategoryEnum
     */
    aws_account_type?: string;
    /**
     * Org id
     */
    org_id: string;
    /**
     * If true, set aws_account_type to null and then check aws_account_type should be empty. Else leave it unchanged.
     */
    reset_aws_account_type_to_null?: boolean;
    service_type: ServiceTypeEnum;
    /**
     * Authorize state. Need to validate against values in SeedOAuthAppStateEnum
     */
    state?: string;
}
export namespace SeedOAuthAuthorizeUpdateSpec {
}


